import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IOrderStatus } from '../../types/newbuilding/flatViewOrder';
import { INewbuilding, TComparisonStatus } from '../../types/newbuilding/newbuilding';
import { TLikeStatus } from '../../types/newbuilding/reviews';
import { changeReviewReactionType } from '../../utils/changeReviewReactionType';

export type TSetReviewReactionActionPayload = {
  reviewId: string;
  type: TLikeStatus;
};

const initialState: INewbuilding = {} as INewbuilding;

export const newbuildingSlice = createSlice({
  name: 'newbuilding',
  initialState,
  reducers: {
    setIsFavorite: (state, action: PayloadAction<boolean>) => {
      state.isFavorite = action.payload;
    },
    setComparisonStatus: (state, action: PayloadAction<TComparisonStatus | null | undefined>) => {
      state.comparisonStatus = action.payload;
    },
    setFlatViewOrder: (state, action: PayloadAction<IOrderStatus>) => {
      state.flatViewOrder = {
        ...state.flatViewOrder,
        isEnabled: (state.flatViewOrder && state.flatViewOrder.isEnabled) || false,
        orderStatus: action.payload,
      };
    },
    setReviewReactionAction: (state, action: PayloadAction<TSetReviewReactionActionPayload>) => {
      const { reviewId, type } = action.payload;

      state.reviews = changeReviewReactionType({
        reviews: state.reviews,
        payload: { reviewId, type },
      });
    },
  },
});

export const {
  reducer: newbuildingReducer,
  actions: { setIsFavorite, setComparisonStatus, setFlatViewOrder, setReviewReactionAction },
} = newbuildingSlice;
